import { MDBBtn, MDBChip, MDBIcon, MDBInputGroup, MDBModalFooter, MDBTable, MDBTableBody, MDBTableHead } from "mdb-react-ui-kit";
import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { customSearch, useAutoFocusSearchAfterLoads } from "../../../components/CustomSearchUtil/CustomSearch";
const AddToGroup = (props) => {
    const { t, i18n } = useTranslation();
    const [selectedRows, setSelectedRows] = useState([]);
    const [addGroups, setAddGroups] = useState([]);
    const [removeGroups, setRemoveGroups] = useState([]);
    const [updatesourcedel, setUpdateSourceDel] = useState(false);
    const [selecteddGroups, setSelecteddGroups] = useState([]);
    const [prevaddedGroups, setPrevAddedGroups] = useState([]);
    const [sourceGroups, setSourceGroups] = useState([]);
    const [removeddGroups, setRemoveddGroups] = useState([]);
    const [searchSourceQuery, setSearchSourceQuery] = useState('');
    const [searchDetinationQuery, setSearchDetinationQuery] = useState('');
    const [addGroupsCodes, setAddGroupsCodes] = useState(new Set());
    const [validationMsg, setValidationMsg] = useState('');
    const [dataLoaded, setDataLoaded] = useState(false);
    const searchRef = useRef(null);
    useAutoFocusSearchAfterLoads(dataLoaded, setDataLoaded, searchRef, true)
    const basicData = {
        columns: [
            { label: "Name", field: "title", sort: true },
            { label: "Extension", field: "extensions" },
            // { label: "Code", field: "code" },
            { label: "location", field: "location_name" },
        ],
        rows: sourceGroups
    };

    if(props?.isglobal){
        basicData.columns.splice(1, 0, { label: "Type", field: "type" });
    }

    const addGroup = (selectedObj) => {
        if(validationMsg) setValidationMsg('');
        const itemIdex = addGroups.findIndex((item) => item.code === selectedObj.code);
        if (itemIdex === -1) {
            const updatedGroups = [...addGroups, selectedObj];
            setAddGroups(updatedGroups);
            const addGroupsCode = new Set(updatedGroups.map(item => item.code));
            setAddGroupsCodes(addGroupsCode);
        } else {
            const updateList = [...addGroups];
            updateList.splice(itemIdex, 1);
            setAddGroups(updateList);
            const addGroupsCode = new Set(updateList.map(item => item.code));
            setAddGroupsCodes(addGroupsCode);
        }

        const newRemoveList = removeGroups.filter(item => item.code !== selectedObj.code);
        setRemoveGroups(newRemoveList);

    }

    const handleDelete = (removeObj) => {
        const updateAddList = addGroups.filter((item) => item.code !== removeObj.code);
        setAddGroups(updateAddList);
        const addGroupsCode = new Set(updateAddList.map(item => item.code));
        setAddGroupsCodes(addGroupsCode);
    }

    const filteredData = customSearch(sourceGroups, searchSourceQuery, [ "title", "extensions", "location_name" ]);

    function setSelectAll(e) {
        e.preventDefault();
        e.stopPropagation();
        if (filteredData.length === 0) {
            return;
        }
        const addgroupcode = new Set(addGroups.map(item => item.code));
        const newAddGroups = filteredData.filter(item => !addgroupcode.has(item.code));
        const finalAddGroups = addGroups.concat(newAddGroups);
        setAddGroups(finalAddGroups);
        const finaladdgroupcodes = new Set(finalAddGroups.map(item => item.code));
        setAddGroupsCodes(finaladdgroupcodes);
    }

    useEffect(() => {
        if (props.sourceGroups?.length > 0 && !updatesourcedel) {
            setSelecteddGroups(props.selectedGroups);
            const selectedGroupsCode = new Set(props.selectedGroups.map(item => item.code));
            const updatedSourceList = props.sourceGroups.filter(items => !selectedGroupsCode.has(items.code));
            setSourceGroups(updatedSourceList);
            setUpdateSourceDel(true);
        }
        if (!dataLoaded) {
        setDataLoaded(true);
    }
    }, [props.sourceGroups, updatesourcedel]);

    function setFinalAddGroups(e) {
        e.preventDefault();
        e.stopPropagation();
        if(addGroups.length === 0){
            setValidationMsg("Please select at least one group to proceed.")
            return;
        }
        setValidationMsg('')
        props.setUpdateGroups(addGroups);
        props.setUpdateGroupsExecuted(true);
        props.onClose();
    }


    return (
        <>
            <div>
                <div className="pt-3">
                    {(selecteddGroups?.length>0 || addGroups?.length>0) && (
                    <MDBInputGroup className='mb-3' textAfter={<MDBIcon fas icon='search' />}>
                        <input className='form-control' type='text' placeholder='Search'
                            value={searchDetinationQuery}
                            onChange={(e) => setSearchDetinationQuery(e.target.value)}
                        />
                    </MDBInputGroup>)}
                    <div className="form-group row">
                        <div className="col-12">
                            <div className="form-outlines phoneNumberheight p-0">
                                <div className="chips chips-placeholder">
                                {selecteddGroups && selecteddGroups.length > 0 || addGroups && addGroups.length > 0 ? <>
                                    {/* {selecteddGroups && selecteddGroups.length > 0 && (
                                        selecteddGroups.filter((item) => {
                                            const lowercasedTitle = item.title.toLowerCase();
                                            const isTitleMatch = lowercasedTitle.includes(searchDetinationQuery.toLowerCase());
                                            const isCodeMatch = item.code && item.code.toString().includes(searchDetinationQuery);
                                            return isTitleMatch || isCodeMatch;

                                        })
                                            .map((item) => ( */}
                                        {selecteddGroups && selecteddGroups.length > 0 && (
                                           customSearch(selecteddGroups, searchDetinationQuery, [ "title", "extensions" ]).map((item) => (
                                                <MDBChip
                                                    key={item.code} className="m-chip d-inline py-2 px-3">
                                                    {item.title}
                                                </MDBChip>
                                            ))
                                    )}
                                    {addGroups && addGroups.length > 0 && (
                                           customSearch(addGroups, searchDetinationQuery, [ "title", "extensions" ]).map((item) => (
                                                <MDBChip
                                                    onDelete={() => handleDelete(item)} className="m-chip d-inline py-2 px-3"
                                                    key={item.code} closeIcon size="sm">
                                                    {item.title}
                                                </MDBChip>
                                            ))
                                    )}
                                     </> : <>
                                        <p className='m-1 text-secondary'>
                                            The selected Groups will appear in this section
                                        </p>
                                    </>}

                                </div>
                            </div>
                            <div>
                                {validationMsg && (
                                    <div className="text-danger">{validationMsg}</div>
                                )}
                                
                            </div>
                            <label className="my-3 text-primary cursor-pointer " onClick={(e) => setSelectAll(e)}>
                                {t("selectAll")}
                            </label>
                            <MDBInputGroup className='mb-3' textAfter={<MDBIcon fas icon='search' />}>
                                <input className='form-control' ref={searchRef} type='text' placeholder='Search'
                                    value={searchSourceQuery}
                                    onChange={(e) => setSearchSourceQuery(e.target.value)} />
                            </MDBInputGroup>
                            <div className="addAdminTable_height">
                                <MDBTable className="mt-3"
                                    hover
                                    itemScope
                                    small
                                >
                                    <MDBTableHead className="table-header-sticky">
                                        <tr >
                                            {basicData?.columns &&
                                                basicData.columns.map((col) => {
                                                    return (
                                                        <th scope='col' key={col.field}>
                                                            {col.label}
                                                        </th>
                                                    );
                                                })}
                                        </tr>
                                    </MDBTableHead>
                                    <MDBTableBody>
                                        {filteredData.length > 0 && 
                                                filteredData
                                                .map((row) => (
                                                    <tr

                                                        className={addGroupsCodes?.has(row.code) ? 'addUsers-select' : ''}
                                                        onClick={() => addGroup(row)}>

                                                        {basicData?.columns.map((column) => (

                                                            <td className="cursor-pointer" >
                                                                {row[column.field]}
                                                            </td>
                                                        ))}
                                                    </tr>
                                                ))}
                                        {filteredData == undefined || filteredData?.length == 0 &&
                                            <td colSpan={3} className="text-center">
                                                No records found
                                            </td>
                                        }
                                    </MDBTableBody>
                                </MDBTable>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <MDBModalFooter>
                <MDBBtn color="secondary" onClick={(e) => props.onClose(e)}>
                    {t("close")}
                </MDBBtn>
                <MDBBtn onClick={(e) => setFinalAddGroups(e)}>{t("add")}</MDBBtn>
            </MDBModalFooter>
        </>
    )
}
export default AddToGroup;